module.exports = __webpack_public_path__ + "static/media/warm_cozy.5acc49bf.svg";